import { render, staticRenderFns } from "./SettingRow.vue?vue&type=template&id=643d6218&scoped=true"
import script from "./SettingRow.vue?vue&type=script&lang=ts"
export * from "./SettingRow.vue?vue&type=script&lang=ts"
import style0 from "./SettingRow.vue?vue&type=style&index=0&id=643d6218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643d6218",
  null
  
)

export default component.exports